import { useEffect } from 'react';
import FortuneWheel from './FortuneWheelContent';
import styles from './FortuneWheelPage.module.scss';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '@/components/BackButton';

const FortuneWheelPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    useNavMenuStore.getState().setVisibility(false);

    return () => {
      useNavMenuStore.getState().setVisibility(true);
    };
  }, []);

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className={styles.fortuneWheelPage}>
      <BackButton onClick={handleBackClick} />
      {/* <div className={styles.customWebHeader}>Колесо фортуны</div> */}
      <div
        style={{
          position: 'relative',
          zIndex: 3,
        }}
      >
        <FortuneWheel />
      </div>
    </div>
  );
};

export default FortuneWheelPage;
